/**
 * @ionic/pwa-elements 1.5.2 crashes in `initPhotoCapabilities` with
 * "Cannot read properties of undefined (reading 'length')" on devices
 * without a flash, because Chrome's native ImageCapture.getPhotoCapabilities()
 * omits `fillLightMode` while the library unconditionally reads `.length` on it.
 * Wrap the prototype once at bootstrap so the field is always an array.
 */
export const installPwaCameraImageCaptureShim = (): void => {
  const w = window as any;
  if (!w || !w.ImageCapture || w.__hbcImageCaptureFillLightModeShim) {
    return;
  }
  const proto = w.ImageCapture.prototype;
  const original = proto.getPhotoCapabilities;
  if (typeof original !== 'function') {
    return;
  }
  proto.getPhotoCapabilities = async function patched(...args: any[]) {
    const caps = await original.apply(this, args);
    if (caps && !Array.isArray(caps.fillLightMode)) {
      caps.fillLightMode = [];
    }
    return caps;
  };
  w.__hbcImageCaptureFillLightModeShim = true;
};

/**
 * Inverts the camera preview box, by default the PWA camera elements
 * adds a style to the video element to invert, this function
 * will clear out that transform. Due to the way the pwa element
 * is built, we need to check if the component is available before
 * clearing out the style. It will be done with the setInterval for retries
 */
export const InvertPreviewCamera = () => {
  let numberOfTries = 0;
  let maxNumberOfTries = 5;
  const timerHandle = setInterval(() => {
    let didChangeCameraTransform: boolean = false;

    const modalInstance: any = document.querySelector('pwa-camera-modal-instance');
    if (modalInstance !== undefined && !!modalInstance) {
      const camera = modalInstance.shadowRoot.querySelector('pwa-camera');
      if (camera !== undefined && !!camera) {
        const video = camera.shadowRoot.querySelector('.camera-wrapper .camera-video video');
        if (video !== undefined && !!video) {
          video.style.transform = null;
          didChangeCameraTransform = true;
        }
      }
    }

    numberOfTries++;
    if (didChangeCameraTransform === true || numberOfTries === maxNumberOfTries) {
      clearInterval(timerHandle);
    }
  }, 200);
};
